/**
 * Feature Callout Slider Block
 *
 * Adopted from old SBW site flexible content block.
 */

/**
 * Initialize the feature callout blocks.
 *
 * return {void}
 */
function initCalloutBlocks() {
	const calloutBlocks = document.querySelectorAll(
		'.paragon-feature-callout-slider-block'
	);
	calloutBlocks.forEach((calloutBlock) => {
		// Find the tallest item and set a CSS var to that height.
		const maxDetailHeight = Array.from(
			calloutBlock.querySelectorAll(
				'.sbw-feature-callout__benefit-detail'
			)
		).reduce((max, detail) => {
			const elHeight = detail.getBoundingClientRect().height;
			return elHeight > max ? elHeight : max;
		}, 150);
		calloutBlock.style.setProperty(
			'--benefit-detail-height',
			maxDetailHeight + 'px'
		);

		const benefitButtons = calloutBlock.querySelectorAll(
			'button.sbw-feature-callout__benefit'
		);
		benefitButtons.forEach(function (benefitButton) {
			benefitButton.addEventListener('click', function () {
				pauseShow();
				const newActive = calloutBlock.querySelector(
					`#${benefitButton.attributes['aria-controls'].value}`
				);
				const oldActive = calloutBlock.querySelector(
					'.sbw-feature-callout__benefit-detail--active'
				);
				if (newActive !== oldActive) {
					toggleActiveBenefit(
						newActive,
						oldActive,
						benefitButtons,
						calloutBlock
					);
				}
			});
		});

		// Find the current and next benefit and toggle them.
		function cycleBenefits() {
			const oldActive = calloutBlock.querySelector(
				'.sbw-feature-callout__benefit-detail--active'
			);
			const oldActiveIndex = parseInt(oldActive.dataset.benefit) + 1;
			const newActiveIndex =
				oldActiveIndex === benefitButtons.length ? 0 : oldActiveIndex;
			const newActive = calloutBlock.querySelector(
				'.sbw-feature-callout__benefit-detail[data-benefit="' +
					newActiveIndex +
					'"]'
			);
			toggleActiveBenefit(
				newActive,
				oldActive,
				benefitButtons,
				calloutBlock
			);
		}

		let startupDelay, preventAnimation, slideTiming;

		function startShow() {
			startupDelay = window.setTimeout(cycleBenefits, 5000);
			slideTiming = window.setInterval(cycleBenefits, 12000);
		}

		function pauseShow() {
			window.clearInterval(startupDelay);
			window.clearInterval(slideTiming);
			window.clearTimeout(preventAnimation);
			preventAnimation = window.setTimeout(startShow, 15000);
		}

		function stopShow() {
			window.clearInterval(startupDelay);
			window.clearInterval(slideTiming);
			window.clearTimeout(preventAnimation);
			window.onfocus = startShow;
		}

		startShow();
		window.onblur = stopShow;
	});

	// Set classes and attributes when the active benefit changes.
	function toggleActiveBenefit(
		newActive,
		oldActive,
		benefitButtons,
		calloutBlock
	) {
		benefitButtons.forEach(function (btn) {
			btn.setAttribute(
				'aria-expanded',
				btn.attributes['aria-controls'].value === newActive.id
			);
		});
		oldActive.classList.remove(
			'sbw-feature-callout__benefit-detail--active'
		);
		oldActive.classList.add(
			'sbw-feature-callout__benefit-detail--transition'
		);
		newActive.classList.add('sbw-feature-callout__benefit-detail--active');
		if (calloutBlock.dataset.animate) {
			calloutBlock.style.setProperty('--overlay-opacity', '1');
			setTimeout(function () {
				calloutBlock.style.setProperty(
					'--sbw-feature-bg-image',
					`url(${newActive.dataset.benefitImageSrc})`
				);
				calloutBlock.style.setProperty('--overlay-opacity', '0');
			}, 250);
		}
		// Set the active benefit image.
		const benefitImages = calloutBlock.querySelectorAll(
			'.sbw-feature-callout__benefit-image'
		);
		benefitImages.forEach(function (benefitImage) {
			benefitImage.classList.remove(
				'sbw-feature-callout__benefit-image--active'
			);

			if (benefitImage.dataset.benefit === newActive.dataset.benefit) {
				benefitImage.classList.add(
					'sbw-feature-callout__benefit-image--active'
				);
			}
		});

		setTimeout(function () {
			oldActive.classList.remove(
				'sbw-feature-callout__benefit-detail--transition'
			);
		}, 500);
	}
}

document.addEventListener('DOMContentLoaded', function () {
	initCalloutBlocks();
});
